import Index from '../../pages/servitor/circus/index';
import Query from '../../pages/servitor/circus/query';

const base = 'circus';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/query*`,
    name: `${base}-query`,
    component: Query
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/servitor/circus.js